import React from 'react';
import { Trans } from '@lingui/react/macro';
import { ValidationScope } from '@/components/forms/validation';
import theme from './EditProductWizardStepImages.module.scss';
import { ProductSourceCatalog, ProductFileAttachment, ProductFileImage, LocalUnsaved } from '@/types';
import AttachmentList from '@/components/AttachmentList';
import { SortableImageUpload, SortableImageUploadProps } from '@/components/SortableImageUpload';
import { getProjectCatalogProductFileThumbnailUrl, getProjectCatalogProductFileUrl } from '@/services/project-catalog';
import { getProfileCatalogProductFileThumbnailUrl, getProfileCatalogProductFileUrl } from '@/services/profile-catalog-products';

function getCatalogUrls(sourceCatalog: ProductSourceCatalog): Pick<SortableImageUploadProps, 'getThumbnailUrl' | 'getUrl'> {
    if (sourceCatalog === ProductSourceCatalog.Project) {
        return {
            getThumbnailUrl: getProjectCatalogProductFileThumbnailUrl,
            getUrl: getProjectCatalogProductFileUrl,
        };
    } else {
        return {
            getThumbnailUrl: getProfileCatalogProductFileThumbnailUrl,
            getUrl: getProfileCatalogProductFileUrl,
        };
    }
}

interface EditProductWizardStepImagesProps {
    sourceCatalog: ProductSourceCatalog;
    images: LocalUnsaved<ProductFileImage>[];
    onImageChange: (images: LocalUnsaved<ProductFileImage>[]) => void;
    onAttachmentsChange: (attachments: ProductFileAttachment[]) => void;
    attachments: ProductFileAttachment[];
}
const EditProductWizardStepImages: React.FC<EditProductWizardStepImagesProps> = ({
    images,
    onImageChange,
    sourceCatalog,
    attachments,
    onAttachmentsChange,
}) => {
    return (
        <ValidationScope>
            <div className={theme.container}>
                <SortableImageUpload files={images} onImagesChange={onImageChange} {...getCatalogUrls(sourceCatalog)} />
            </div>

            <h5>
                <Trans>You can add attachments that contain details about this product in, for example, PDF form.</Trans>
            </h5>
            <AttachmentList
                onChange={(e) => onAttachmentsChange(e)}
                urlGenerator={() => ''}
                value={attachments}
                allowPaste
            />
        </ValidationScope>
    );
};

export default EditProductWizardStepImages;
